import api from './api';

export const uploadCCTransactions = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/pl/upload-cc', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getUploads = async () => {
  const response = await api.get('/pl/uploads');
  return response.data;
};

export const deleteUpload = async (id) => {
  const response = await api.delete(`/pl/uploads/${id}`);
  return response.data;
};

export const getRevenue = async (params = {}) => {
  const response = await api.get('/pl/revenue', { params });
  return response.data;
};

export const getRevenueHistograms = async (params = {}) => {
  const response = await api.get('/pl/revenue/histograms', { params });
  return response.data;
};

export const getWashPackageMix = async (params = {}) => {
  const response = await api.get('/pl/revenue/wash-mix', { params });
  return response.data;
};

export const uploadUtilityBill = async (formData) => {
  const response = await api.post('/pl/utility-bills', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getUtilityBills = async () => {
  const response = await api.get('/pl/utility-bills');
  return response.data;
};

export const updateUtilityBill = async (id, data) => {
  const response = await api.put(`/pl/utility-bills/${id}`, data);
  return response.data;
};

export const deleteUtilityBill = async (id) => {
  const response = await api.delete(`/pl/utility-bills/${id}`);
  return response.data;
};

export const downloadUtilityBill = async (id) => {
  const response = await api.get(`/pl/utility-bills/${id}/download`, { responseType: 'blob' });
  return response;
};

export const downloadUtilityBillsBulk = async (ids) => {
  const response = await api.post('/pl/utility-bills/download-bulk', { ids }, { responseType: 'blob' });
  return response;
};

export const getSalesTaxStatus = async () => {
  const response = await api.get('/pl/sales-tax/status');
  return response.data;
};

export const createSalesTaxTransfer = async (data) => {
  const response = await api.post('/pl/sales-tax/transfers', data);
  return response.data;
};

export const listSalesTaxTransfers = async () => {
  const response = await api.get('/pl/sales-tax/transfers');
  return response.data;
};

export const deleteSalesTaxTransfer = async (id) => {
  const response = await api.delete(`/pl/sales-tax/transfers/${id}`);
  return response.data;
};

export const setTaxFilingFrequency = async (frequency) => {
  const response = await api.put('/pl/sales-tax/filing-frequency', { frequency });
  return response.data;
};

// ─── Swiper mappings (CryptoPay SwiperID → canonical unit override) ───

export const getSwiperMappings = async () => {
  const response = await api.get('/pl/swiper-mappings');
  return response.data;
};

export const saveSwiperMappings = async (mappings, { remap = true } = {}) => {
  const response = await api.post('/pl/swiper-mappings', { mappings, remap });
  return response.data;
};

export const deleteSwiperMapping = async (id) => {
  const response = await api.delete(`/pl/swiper-mappings/${id}`);
  return response.data;
};

// ─── CryptoPay site mappings (multi-location upload routing) ──────────

export const getSiteMappings = async () => {
  const response = await api.get('/pl/cryptopay-site-mappings');
  return response.data;
};

export const saveSiteMappings = async (mappings) => {
  const response = await api.post('/pl/cryptopay-site-mappings', { mappings });
  return response.data;
};

export const deleteSiteMapping = async (id) => {
  const response = await api.delete(`/pl/cryptopay-site-mappings/${id}`);
  return response.data;
};

// ─── EverWash monthly income reports ─────────────────────────────────

export const uploadEverWashReport = async (file, periodStart) => {
  const formData = new FormData();
  formData.append('file', file);
  if (periodStart) formData.append('period_start', periodStart);
  const response = await api.post('/pl/upload-everwash', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getEverWashMappings = async () => {
  const response = await api.get('/pl/everwash-site-mappings');
  return response.data;
};

export const saveEverWashMappings = async (mappings) => {
  const response = await api.post('/pl/everwash-site-mappings', { mappings });
  return response.data;
};

export const getEverWashMonths = async () => {
  const response = await api.get('/pl/everwash-months');
  return response.data;
};

export const deleteEverWashMonth = async (id) => {
  const response = await api.delete(`/pl/everwash-months/${id}`);
  return response.data;
};
